/*
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-17 17:02:01
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/mine.js
 */
import request from "@/utils/request";
// 地址选择器数据
export async function getAllAddress() {
  const url = "/api/front/order/address/getAllAddress";
  return request(url);
}
// 获取地址数据Map
export async function getAllAddressMap() {
  const url = "/api/front/order/address/getAllAddressMap";
  return request(url);
}

// 删除用户地址
export async function deleteAddress(params) {
  const url = `/api/front/order/address/deleteAddress/${params.id}`;
  return request(url, {
    method: "DELETE"
  });
}
// 用户地址列表
export async function getUserAddress(params) {
  const url = `/api/front/order/address/getUserAddress`;
  return request(url, { params });
}
// 我的页面数据
export async function getUserInfo() {
  const url = "/api/front/user/getUserInfo";
  return request(url);
}
// 我的页面卡券数据
// export async function queryCardVoucherUserCount() {
//   const url = "/api/product/cardVoucherUser/queryCardVoucherUserCount";
//   return request(url);
// }
// 修改个人信息
export async function updateUserInfo(params) {
  const url = "/api/front/user/updateUserInfo";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 实名认证列表
export async function findCertificationByPage(params) {
  const url = "/api/front/certification/findCertificationByPage";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 设置默认实名认证
export async function setDefault(params) {
  const url = `/api/front/certification/setDefault/${params.id}`;
  return request(url, {
    method: "POST"
  });
}
// 删除实名认证列表
export async function removeCertification(params) {
  const url = `/api/front/certification/removeCertification/${params.id}`;
  return request(url, {
    method: "POST"
  });
}
// 添加实名认证列表
export async function addCertification(params) {
  const url = `/api/front/certification/addCertification`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 获取真实手机号
export async function getUserPhone() {
  const url = `/api/front/user/getUserPhone`;
  return request(url);
}
// 修改登录密码
export async function changePassword(params) {
  const url = `/api/front/user/changePassword`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 修改手机号
export async function changePhone(params) {
  const url = `/api/front/user/changePhone`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 添加收货地址
export async function addAddress(params) {
  const url = `/api/front/order/address/addAddress`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 修改收货地址
export async function updateAddress(params) {
  const url = `/api/front/order/address/updateAddress`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 智能识别地址
export async function addressConsigneeInformation(params) {
  const url = `/api/front/order/address/consigneeInformation`;
  return request(url, { params });
}
// 获取单个收货地址信息
export async function getAddressById(params) {
  const url = `/api/front/order/address/getAddressById`;
  return request(url, { params });
}
// 个人中心绑定微信
export async function wechatBinding(params) {
  const url = `/api/front/user/wechatBinding`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 上传实名认证照片
export async function upload(params) {
  const url = `/api/front/daemon/files/upload?kind=${params.data.kind}&sourceId=${params.data.sourceId}`;
  var fromData = new FormData();
  fromData.append("file", params.file);
  return request(url, {
    method: "POST",
    data: fromData
  });
}
// 卡包列表
export async function queryCardVoucherUserPackage() {
  const url = `/api/front/product/cardVoucherUser/queryCardVoucherUserPackage`;
  return request(url);
}
// 卡券列表
export async function queryCardVoucherUserByPage(params) {
  const url = `/api/front/product/cardVoucherUser/queryCardVoucherUserByPage`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 使用记录
export async function queryCardVoucherUserRecordByPage(params) {
  const url = `/api/front/product/cardVoucherUser/queryCardVoucherUserRecordByPage`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 卡券详情
export async function queryCardVoucherUserById(params) {
  const url = `/api/front/product/cardVoucherUser/queryCardVoucherUserById/${params.id}`;
  return request(url);
}
// 分享获取用户信息
export async function getSimpleUserInfo() {
  const url = `/api/front/user/getSimpleUserInfo/-1`;
  return request(url);
}

// 获取用户优惠券列表
export async function getCouponListByUser(params) {
  const url = "/api/front/product/coupon/getCouponListByUser";
  return request(url, { params });
}
